_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('action')
entityTemplate = require './entity'
memberAvatarTemplate = require './member_avatar'
actionFooterTemplate = require './action_footer'
contentEntityTypes = ['attachmentPreview', 'comment', 'checkList']

module.exports = t.renderable (data, context, options) ->
  { entities, saved, dateLastEdited, date, url } = data
  { member, showReactions, showInlineReactionButton } = context
  { useEmbedly, usePreviews } = options
  needsDate = true

  t.div '.phenom-creator', ->

    if member
      t.div '.member.js-show-mem-menu', { idmember: member.id }, ->
        memberAvatarTemplate(member)
    else
      t.span '.icon-lg.icon-member'

  t.div '.phenom-desc', ->

    for entity in entities
      if entity.type in contentEntityTypes # we only want to render the date before the entity that contains content
        needsDate = false
        t.span '.inline-spacer', ->
          t.text ' '
        t.span '.phenom-date.quiet', ->
          if saved
            if url
              t.a '.date.js-hide-on-sending.js-highlight-link', { dt: date, href: url }
            else
              t.span '.date.js-hide-on-sending', { dt: date, href: url }
          if dateLastEdited
            t.span '.js-date-title.js-hide-on-sending', { dt: dateLastEdited }, ->
              t.text ' '
              t.format 'edited'
      entityTemplate(entity, context, options)

    if useEmbedly
      t.div '.hide.embedly.js-embedly'

    if usePreviews
      t.div '.hide.previews.js-previews'

  if showReactions
    t.div '.phenom-reactions', ->
      t.div '.js-reaction-piles.reaction-piles-container',
        class: t.classify(
          'last': showInlineReactionButton
          'reaction-piles-container-full': !showInlineReactionButton
        )
      actionFooterTemplate(data, context, _.extend(options, { needsDate }))
  else
    actionFooterTemplate(data, context, _.extend(options, { needsDate }))



// WEBPACK FOOTER //
// ./app/scripts/views/templates/action.coffee